// extracted by mini-css-extract-plugin
module.exports = {"order-search":"OrderSearch_style_order-search__2OUkd"};